export const FEE_DATA = [
    {
        code: "CT001",
        value: 0,
    },
    {
        code: "CT002",
        value: 0,
    },
    {
        code: "CT003",
        value: 0,
    },
    {
        code: "CT004",
        value: 0,
    },
    {
        code: "CT005",
        value: 0,
    },
    {
        code: "CT006",
        value: 0,
    },
    {
        code: "CT007",
        value: 0,
    },
    {
        code: "CT008",
        value: 0,
    },
    {
        code: "CT009",
        value: 0,
    },
    {
        code: "CT010",
        value: 0,
    },
    {
        code: "CT011",
        value: 0,
    },
    {
        code: "CT012",
        value: 0,
    },
    {
        code: "CT013",
        value: 0,
    },
    {
        code: "CT014",
        value: 0,
    },
    {
        code: "CT015",
        value: 0,
    },
    {
        code: "CT016",
        value: 0,
    },
    {
        code: "CT017",
        value: 0,
    },
    {
        code: "CT018",
        value: 0,
    },
    {
        code: 'CT019',
        value: 0
    },
    {
        code: 'CT020',
        value: 0
    },
];

export const NORM_DATA = [
    {
        code: "OLQ001",
        value: 0,
    },
    {
        code: "OLQ002",
        value: 0,
    },
    {
        code: "OLQ003",
        value: 0,
    },
    {
        code: "OLQ004",
        value: 0,
    },
    {
        code: "OLQ005",
        value: 0,
    },
    {
        code: "OLQ006",
        value: 0,
    },
    {
        code: "OLQ007",
        value: 0,
    },
]

export const CONTRACT_STATUS = {
    WAITING_ASSIGN_CAR: 1,
    ASSIGNED_CAR: 2,
    IN_PROGRESS: 3,
    FINISHED: 4,
    CANCELED: 5
}

export const CARD_TYPE = {
    IDENTITY_CARD: 1,
    CITIZEN_IDENTIFICATION: 2,
    PASSPORT: 3,
}

export const CUSTOMER_CODE = {
    enterprise: 'CT002',
    personal: 'CT001'
}

export const CONTRACT_TYPE = {
    has_driver: 'contract_with_driver',
    without_driver: 'contract_without_driver'
}

export const TRANSMISSION_TYPE ={
    MT: 1,
    AT: 2
}

export const CAR_STATUS = {
    KTDD: 0,
    CDD: 1,
    DDD: 2,
}

export const dateFormatVi = {
    'Monday': "Hai",
    'Tuesday': "Ba",
    'Wednesday': "Tư",
    'Thursday': 'Năm',
    'Friday': 'Sáu',
    'Saturday': 'Bảy',
    'Sunday': 'Chủ nhật'
}

export const ACCOUNT_STATUS = {
    ACTIVE: 0,
    INACTIVE: 1,
}